import React from 'react'
import { Link } from 'react-router-dom'
import { Header, HeaderName, HeaderMenuButton } from 'carbon-components-react'

import useIsMobile from '../../useIsMobile'
import Navigation from '../Navigation'
import './index.scss'

export default ({
  headerList,
  children,
  isSideNavExpanded,
  onClickSideNavExpand,
  onNavigate,
  logo
}) => {
  const isMobile = useIsMobile()

  return (
    <Header className='ublique-shell-header' aria-label='Ublique Platform Name'>
      {isMobile && (
        <HeaderMenuButton
          aria-label='Open menu'
          isCollapsible
          onClick={onClickSideNavExpand}
          isActive={isSideNavExpanded}
        />
      )}
      <HeaderName
        element={Link}
        to='/'
        prefix=''
        className='ublique-shell-logo'
      />
      {logo && (
        <div className='ublique-shell-logo--product bx--header__nav'>
          <img src={logo} />
        </div>
      )}
      <Navigation
        items={headerList}
        type='header'
        onNavigate={onNavigate}
        isSideNavExpanded={isSideNavExpanded}
        onClickSideNavExpand={onClickSideNavExpand}
      />
      {children}
    </Header>
  )
}
